"use strict";
/**
 * Ось B — ПЛАТФОРМЕННАЯ ДОЛЖНОСТЬ (RBAC-1 AD-1).
 *
 * «Сотрудник платформы»: 0..n ролей, по умолчанию 0, назначает человек и редко.
 * Ось B — единственная, где имя роли законно участвует в решении о доступе: у
 * платформенного админа членств НЕТ и не будет (RBAC-1.3 Р-6), поэтому его ветка
 * не может прийти из членства и обязана прийти из имени.
 *
 * Здесь перечислены ВСЕ живые имена. Словарь описывает то, что лежит в базе, а не то,
 * что кто-то проверяет, — иначе сторож AC-8 начнёт краснеть на правде.
 *
 * ⚠ RBAC-2.5 сняла отсюда `merchant`, `readonly` и `test_perf_role` — все три выведены
 * из обращения миграцией `2026-08-28_rbac_2_5_drop_dead_roles.sql`. Заводить их заново
 * нельзя: словарь и база обязаны говорить одно и то же, и односторонний инвариант 1.9
 * AC-2 («схема ⊆ словарь») эту сторону НЕ проверяет.
 *
 * ⚠ `moderator` и `content_manager` мёртвыми БЫТЬ ПЕРЕСТАЛИ и из списка на удаление
 * выведены: первой RBAC-2.4 выдала `conversations:read_all`, второй RBAC-2.9 —
 * `content:moderate` и `manage_news`. Обе при этом остаются именами, которых НЕ
 * называет ни один гейт: доступ им даёт право, и снятие права отнимает его у всех
 * держателей разом — в этом и был предмет эпика.
 *
 * ⚠ `catalog_admin` — роль с НУЛЁМ прав и живым именем в гейте, и это не противоречие, а
 * прямое следствие AD-2.5 и разделения слоёв: гейт `CatalogRoles.ADMIN`
 * (`catalog/src/presentation/middleware/auth.middleware.ts`) спрашивает ИМЯ роли, а не
 * право. RBAC-2.9 сняла одно из двух употреблений имени (модерацию каталога), MDM-записи
 * остались ролевыми — поэтому 2.5 роль не удалила. Уйдёт следующей уборкой, когда
 * MDM-маршруты назовут своё намерение правом или членством. Пустой список прав НЕ
 * является основанием считать её мёртвой.
 *
 * ⚠ Фантомов здесь нет и не будет. `platform_admin`, `merchant_owner`,
 * `merchant_manager`, `merchant_staff`, `merchant_operator` не существуют ни на dev,
 * ни на проде — снято запросом к обеим базам 2026-08-27. Имя-фантом в гейте не
 * отказывает и не пускает: решение принимает то, что осталось в списке рядом.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM_ADMIN_ROLE_NAMES = exports.PLATFORM_ROLE_VALUES = exports.PLATFORM_ROLES = void 0;
exports.isPlatformAdmin = isPlatformAdmin;
exports.PLATFORM_ROLES = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    SUPPORT: 'support',
    MODERATOR: 'moderator',
    CONTENT_MANAGER: 'content_manager',
    /** Прав не держит; имя живо в `CatalogRoles.ADMIN` — см. оговорку в заголовке. */
    CATALOG_ADMIN: 'catalog_admin',
};
exports.PLATFORM_ROLE_VALUES = Object.values(exports.PLATFORM_ROLES);
/**
 * «Платформенный админ» — ОДНО объявление на всю платформу.
 *
 * До RBAC-1.9 этот набор был выписан руками в шести местах, и в четырёх из них вторым
 * именем стоял фантом `platform_admin`. Следствия расходились: гейт 16 админских
 * маршрутов Core сужался до одного `super_admin` (хотя роутером выше уже пущен
 * `admin`), `super_admin` не видел `admin_only` категорий в каталоге, а ops-алерт о
 * провале провижининга не доходил до `admin`. Три разных поведения из одной опечатки —
 * потому что копий было шесть.
 *
 * ⚠ AD-10 — набор `['super_admin', 'admin']` есть РЕШЕНИЕ оператора (2026-08-27), а не
 * орфография. Гейт всегда обещал «платформенный админ», и gateway на тех же путях уже
 * пускает `admin` (`required_roles: [admin, super_admin]` во всех 77 записях); после
 * правки два слоя enforcement перестают утверждать разное. Цена сегодня нулевая:
 * держателей `admin` на проде 0, на dev 1.
 */
exports.PLATFORM_ADMIN_ROLE_NAMES = [
    exports.PLATFORM_ROLES.SUPER_ADMIN,
    exports.PLATFORM_ROLES.ADMIN,
];
/** Держит ли этот набор ролей платформенного админа. */
function isPlatformAdmin(roles) {
    if (!roles)
        return false;
    return roles.some((role) => exports.PLATFORM_ADMIN_ROLE_NAMES.includes(role));
}
